import { useState } from 'react'
import { useParams } from 'react-router-dom'
import DownIcon from 'assets/images/rectangle/down1.svg'
import UpIcon from 'assets/images/rectangle/up1.svg'
import SettlementConfirmModal from 'components/modals/settlementConfirm'
import useRejectSettlement from '../hooks/useRejectSettlement'

interface iItemProps {
    item: IAdminSettlementResult
    refetch: () => void
    /** a settlement is already running on this page; don't start a second one */
    isBusy: boolean
    onAccept: (item: IAdminSettlementResult) => void
}

const statusLabel = (status: string | null) => {
    if (status === null) return 'در حال بررسی'
    return status === 'rjc' ? 'رد شده' : 'پذیرفته شده'
}

export default function Item({ item, refetch, isBusy, onAccept }: iItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isConfirmingReject, setIsConfirmingReject] = useState(false)
    const { moneyPool } = useParams()
    const { isRejecting, reject } = useRejectSettlement(refetch)
    const isPending = item.status === null
    const name = `${item.requesting_user.member.first_name} ${item.requesting_user.member.last_name}`

    return (
        <>
            <div
                className=" py-2 px-2 bg-white my-2 mx-2 rounded-md shadow-[4px_4px_25px__rgba(0,0,0,0.1)]"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className=" flex justify-between">
                    <div>{name}</div>
                    <div className=" flex">
                        {/* «پذیرفته شده» is good news and «رد شده» is not, so
                            they stopped sharing one pink pill */}
                        <p
                            className={` mx-2 rounded-full px-2 py-0.5 text-sm ${
                                isPending
                                    ? ' bg-warning-soft text-warning-on'
                                    : item.status === 'rjc'
                                    ? ' bg-error-4 text-gray-4'
                                    : ' bg-success-2 text-success-on'
                            }`}
                        >
                            {statusLabel(item.status)}
                        </p>
                        {isPending && (
                            <img
                                src={isOpen ? UpIcon : DownIcon}
                                alt="down-up"
                            />
                        )}
                    </div>
                </div>
                <p className=" text-sm">{item.discription}</p>
                {isOpen && isPending && (
                    <div className=" flex justify-between my-3">
                        <button
                            disabled={isBusy || isRejecting}
                            onClick={(event) => {
                                event.stopPropagation()
                                onAccept(item)
                            }}
                            className="w-full border-1 border-green-1 rounded-lg text-green-1 bg-green-main py-2 ml-1 disabled:opacity-50"
                        >
                            قبول
                        </button>
                        <button
                            disabled={isBusy || isRejecting}
                            className=" border-1 border-red-1 text-red-1 rounded-lg py-2 w-full mr-1 disabled:opacity-50"
                            onClick={(event) => {
                                event.stopPropagation()
                                setIsConfirmingReject(true)
                            }}
                        >
                            رد
                        </button>
                    </div>
                )}
            </div>

            {/* رد is one tap next to قبول and cannot be undone by the manager,
                so it asks first — as the Android app does */}
            <SettlementConfirmModal
                show={isConfirmingReject}
                onHide={() => setIsConfirmingReject(false)}
                lead="آیا مایل به رد درخواست تسویه و خروج"
                name={name}
                onConfirm={() => {
                    setIsConfirmingReject(false)
                    reject({ moneyPool, id: item.id })
                }}
            />
        </>
    )
}
